import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, Renderer2} from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { startWith, Subscription } from 'rxjs';
import { IAPIResponse } from 'src/app/modules/shared/models';
import { IComponentInput, IMaterialCodeDetail, IVendorCodeDetail } from '../../models';
import { PrInitiatorService } from '../../services/pr-initiator.service';
import { Validators } from '@angular/forms';
import { AdminService } from 'src/app/modules/admin/services/admin.service';
import { PrBuyerHelperService } from 'src/app/modules/pr-buyer/services/pr-buyer-helper.service';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'line-item-form',
  templateUrl: './line-item-form.component.html',
  styleUrls: ['./line-item-form.component.scss']
})
export class LineItemFormComponent implements OnInit, OnDestroy {
  @Input("componentInput") data!: IComponentInput;
  @Output() eventOutput: EventEmitter<any> = new EventEmitter<any>();

  private _subscriptions : Array<Subscription> = [];
  public plant!: any;
  public serviceCategory!:any;
  public gl_account_Options!: any[];
  account_assignment_value_Options: any;
  public showCostCenterDropDown!:boolean;
  public showCostCenterField:boolean = false;
  public showWbsElementField:boolean = false;
  balance:any;
  acc_assignment_category: any;
  wbsElementBalanceDetails: any;
  constructor(private _prInitiatorService: PrInitiatorService,
    private _helperService: PrBuyerHelperService,
    private _adminService:AdminService,
    private _toastrService: ToastrService,private http: HttpClient) {  }

  ngOnInit(): void {
    if(!this.acc_assignment_category && this.data.info?.price) this.acc_assignment_category = this.data?.formGroup?.controls['acc_assignment_category'].value;
    this.data?.formGroup?.controls['acc_assignment_category']?.valueChanges.subscribe(() => {
      this.acc_assignment_category = this.data?.formGroup?.controls['acc_assignment_category'].value
    });
    this.showWbsElementField = this.data?.formGroup?.controls['acc_assignment_category']?.value === 'D-Indiv.cust./project' ? true : false
    const purchaseRequestFormValue = this.data.purchaseRequestForm?.value;
    this.plant = purchaseRequestFormValue?.plant;
    const purchasing_organization = purchaseRequestFormValue?.purchasing_organization;
    this.showCostCenterField = this.data?.formGroup?.controls['acc_assignment_category']?.value === 'F-Order' ? true : false;
    
    this.data?.formGroup?.controls['delivery_date']?.valueChanges
    .pipe(startWith(this.data?.formGroup?.controls['delivery_date']?.value))
    .subscribe((delivery_date: string) => {
      this._prInitiatorService.materialMasterDeliveryDate = delivery_date.split('-')[0];
    });
    // if(this.data.itemCategory == 'Standard'){
    //   if(this.data.tabName == 'Account Details'){
    //     this.data.formGroup.get('gl_account')?.clearValidators();
    //     this.data.formGroup.get('acc_assignment_category')?.clearValidators();
    //     this.data.formGroup.get('acc_assignment_value')?.clearValidators();
    //     this.data.formGroup?.updateValueAndValidity();
    //   }
    // } else {
    //   if(this.data.tabName == 'Account Details'){
    //     this.data.formGroup.get('gl_account')?.setValidators([Validators.required]);
    //     this.data.formGroup.get('acc_assignment_category')?.setValidators([Validators.required]);;
    //     this.data.formGroup.get('acc_assignment_value')?.setValidators([Validators.required]);
    //     this.data.formGroup?.updateValueAndValidity();
    //   }
    // }

    this.data?.formGroup?.controls['item_category']?.valueChanges.subscribe((item_category: string) => {
      if (this.data?.formGroup?.controls['item_category'].value == 'Service') {
        this.data.formGroup.get('material_code')?.setValidators([Validators.required]);
        this.data.formGroup?.updateValueAndValidity();
      }
      else {
        this.data.formGroup.get('material_code')?.clearValidators();
        this.data.formGroup?.updateValueAndValidity();
      }
    })

    this.data?.formGroup?.controls['esn']?.valueChanges.subscribe((esn: string) => {
      this.data?.formGroup?.controls['matl_group'].patchValue(esn);
      console.log("esn...",esn,this.data.formGroup.value)
    })

    this._adminService.getMappedGLAccountsByRole().subscribe((res:any)=>{
      this.gl_account_Options = res.data.map((item:any)=> {return `${item.code} - ${item.description}`});
    })

    this._adminService.getCostCenterMasterData().subscribe((res:any)=>{
      this.account_assignment_value_Options = res.data.map((item:any)=> {return `${item.code} - ${item.name}`});
    })

    this.data?.formGroup?.controls['acc_assignment_category']?.valueChanges.subscribe((item_category: string) => {
      if(this.data?.formGroup?.controls['acc_assignment_category']?.value === 'K-Cost center'){
        this.showCostCenterDropDown  = true;
        this.showWbsElementField = false;
      } else if(this.data?.formGroup?.controls['acc_assignment_category']?.value === 'F-Order'){
        this.showCostCenterField  = true;
        this.showWbsElementField = false;
      }else if(this.data?.formGroup?.controls['acc_assignment_category']?.value === 'D-Indiv.cust./project'){
         this.showWbsElementField = true;
         this.showCostCenterDropDown = false;
        this.showCostCenterField  = false;
      } else {
        this.showCostCenterDropDown = false;
        this.showCostCenterField  = false;
        this.showWbsElementField = false;
      }
    })

    this.data?.formGroup?.controls['material_code']?.valueChanges.subscribe((item_category: string) => {
      // if (!this.data.isMRPPr) {
        if (this.data.formGroup.controls['material_code'].value && this.data.formGroup.controls['item_category'].value) {
          if (this.data.formGroup.controls['item_category'].value === 'Service') {
            // this.data.formGroup.controls['service_category'].patchValue("Other");
              // if(this.data.formGroup.controls['service_category'].value == 'Other'){

                this.detailsForOtherService(this.data.formGroup.controls['material_code'].value)
              // } else{
              //   this.detailByServiceCode(this.data.formGroup.controls['material_code'].value,this.data.formGroup.controls['service_category'].value);
              // }
          } else if(this.data.formGroup.controls['item_category'].value === 'Standard' && (this.data.formGroup.controls['with_material'].value === "true" || this.data.formGroup.controls['with_material'].value === true)) {
            this.detailByMaterialCode(this.data.formGroup.controls['material_code'].value, this.plant);
          }
        }
      // }
    })

    // if(this.data.formGroup.controls['vendor_code']) {
      this._subscriptions.push(
        this.data.formGroup?.controls['vendor_code']?.valueChanges.subscribe((vendor_code : string) => {
          this._prInitiatorService.detailByVendorCode(vendor_code, purchasing_organization).subscribe((res : IAPIResponse<IVendorCodeDetail>) => {

            res.data?.vendor_name && this.data.formGroup.controls["vendor_name"].patchValue(res.data?.vendor_name);
            res.data?.vendor_location && this.data.formGroup.controls["vendor_location"].patchValue(res.data?.vendor_location);

            this.data.formGroup.controls["vendor_name"].markAsTouched();
            this.data.formGroup.controls["vendor_location"].markAsTouched();
          })
        })
      )
// }

    // this.data.formGroup?.controls['short_text']?.valueChanges.subscribe((text: string) => {
    //   // if (this.data.isMRPPr) {
    //     if (this.data.formGroup.controls['item_category'].value === 'Service' && text?.length >= 2)
    //       this.data.formFields[1].selectFields?.apiAsync$ ? this.data.formFields[1].selectFields.apiAsync$ = this._prInitiatorService.searchESN(text) : '';
    //   // }
    // })
  }
  onKeydown(event: { key: string; }) {
      const acc_assignment_category = this.data?.formGroup?.controls['acc_assignment_category'].value;
      this.acc_assignment_category = acc_assignment_category;
      const acc_assignment_value = this.data?.formGroup?.controls['acc_assignment_value'].value;
      const price = this.data?.info ?  this.data.info.price :this.data.priceValue;
      if ((event.key === 'Enter' || event.key === 'Tab') && acc_assignment_category == 'P-Project' ) {
        this._adminService.getWbsElementBalance({ "wbs" : acc_assignment_value, 'year': this._prInitiatorService.materialMasterDeliveryDate}).subscribe(response => {
          this.balance=response.data.balance;
          this.wbsElementBalanceDetails = response.data;
          console.log(response.data)
          this.data.formGroup?.patchValue({
            'WBS_Budget_Total_Value': response.data.allocated_buget,
            'WBS_Utilized_Value': response.data.utilize_budget,
            'WBS_Balance_Value': response.data.balance,
            'Latest_PO_Number':response.data.last_po,
            'FY_YEAR':response.data.year
          });
        if(Number(this.balance) <= Number(price)){
          this._toastrService.error(`Your Balance Amount is less than Budget - Balance: ${this.balance}`);
        }else{
         this._toastrService.success(`You have enough Balance  - Balance: ${this.balance}`);
        }
      });
    }
  }

  onDropDownValueChange(selectedValue: any, formControlName: string){
       const itemCode = selectedValue.split(' - ')[0];
       this.data.formGroup.patchValue({
        [formControlName]: itemCode
      });
  }

  optionValue(data: any[], fieldName: string, label: string) {
    if (fieldName.toLowerCase() == 'esn') {
      if (data?.length && this.data.formGroup.controls['item_category'].value === 'Service' && this.data.formGroup.controls['item_category'].value && this.data.formGroup.controls['short_text'].value) {
        // this.data.formGroup.controls['esn'].setValue(data[0][label]);
        this.data.formGroup.controls["esn"].markAsTouched();
      }
    }
    return data;
  }
  
  detailByServiceCode(material_code: any,category:any) {
    this._prInitiatorService.detailByServiceCodeAndCategory(material_code,category).subscribe((res : any) => {
      this.patchServiceData(res);
    }, err => {
      // this.data.formGroup.controls["currency"].patchValue(null);
      // this.data.formGroup.controls["delivery_date"].patchValue(null);
      // this.data.formGroup.controls["price"].patchValue(null);
      // this.data.formGroup.controls["quantity"].patchValue(null);
      this.data.formGroup.controls["short_text"].patchValue(null);
      this.data.formGroup.controls["esn"].patchValue(null);
      this.data.formGroup.controls["ordering_unit"].patchValue(null);
      this.data.formGroup.controls["item_desc"].patchValue(null);
    });
  }

  detailsForOtherService(material_code:any){
    this._prInitiatorService.detailByServiceCodeAndCategoryOther(material_code).subscribe((res:any)=>{
      this.patchServiceData(res)
    },err =>{
      // this.data.formGroup.controls["currency"].patchValue(null);
      // this.data.formGroup.controls["delivery_date"].patchValue(null);
      // this.data.formGroup.controls["price"].patchValue(null);
      // this.data.formGroup.controls["quantity"].patchValue(null);
      this.data.formGroup.controls["short_text"].patchValue(null);
      this.data.formGroup.controls["esn"].patchValue(null);
      this.data.formGroup.controls["ordering_unit"].patchValue(null);
      this.data.formGroup.controls["item_desc"].patchValue(null);
    }
    )
  }

  patchServiceData(res:any){
    console.log("res",res)
      // this.data.formGroup.controls["delivery_date"].patchValue(res.data?.delivery_date);
      // res.data?.price?this.data.formGroup.controls["price"].patchValue(res.data?.price):'';
      // this.data.formGroup.controls["quantity"].patchValue(res.data?.quantity);
      // this.data.formGroup.controls["short_text"].patchValue(res.data?.short_text);
      // this.data.formGroup.controls["short_text"].patchValue(res.data?.commodity);
      this.data.formGroup.controls["esn"].patchValue(res.data?.material_group);
      this.data.formGroup.controls["matl_group"].patchValue(res.data?.material_group);
      this.data.formGroup.controls["ordering_unit"].patchValue(res.data?.ordering_unit);
      // this.data.formGroup.controls["item_desc"].patchValue(res.data?.item_desc);
      this.data.formGroup.controls["short_text"].patchValue(res.data?.item_desc ? res.data.item_desc : res.data.description);
      this.data.formGroup.controls["hsn_sac"].patchValue(res.data?.hsn_sac);
      
      this.data.formGroup.controls["currency"].markAsTouched();
      this.data.formGroup.controls["delivery_date"].markAsTouched();
      this.data.formGroup.controls["price"].markAsTouched();
      this.data.formGroup.controls["quantity"].markAsTouched();
      this.data.formGroup.controls["short_text"].markAsTouched();
      this.data.formGroup.controls["esn"].markAsTouched();
      this.data.formGroup.controls["ordering_unit"].markAsTouched();
      this.data.formGroup.controls["item_desc"].markAsTouched();
  }


  detailByMaterialCode(material_code: any, plant: any) {
    console.log("plant",this.plant)
      this._prInitiatorService.detailByMaterialCode(material_code, plant).subscribe((res : IAPIResponse<IMaterialCodeDetail>) => {
        res.data?.currency && this.data.formGroup.controls["currency"].patchValue(res.data?.currency);
        res.data?.delivery_date && this.data.formGroup.controls["delivery_date"].patchValue(res.data?.delivery_date);
        this.data.formGroup.controls["price"].patchValue(res.data?.price?res.data?.price:0);
        res.data?.quantity && this.data.formGroup.controls["quantity"].patchValue(res.data?.quantity);
        res.data?.item_desc && this.data.formGroup.controls["short_text"].patchValue(res.data?.item_desc);
        this.data.formGroup.controls["esn"].patchValue(res.data?.matl_group);
        this.data.formGroup.controls["matl_group"].patchValue(res.data?.matl_group);
        this.data.formGroup.controls["ordering_unit"].patchValue(res.data?.ordering_unit);
        // res.data?.item_desc && this.data.formGroup.controls["item_desc"].patchValue(res.data?.);
        this.data.formGroup.controls["hsn_sac"].patchValue(res.data?.control_code);
        this.data.formGroup.controls["currency"].markAsTouched();
        this.data.formGroup.controls["delivery_date"].markAsTouched();
        this.data.formGroup.controls["item_category"].markAsTouched();
        this.data.formGroup.controls["price"].markAsTouched();
        this.data.formGroup.controls["quantity"].markAsTouched();
        this.data.formGroup.controls["short_text"].markAsTouched();
        this.data.formGroup.controls["esn"].markAsTouched();
        this.data.formGroup.controls["ordering_unit"].markAsTouched();
        this.data.formGroup.controls["item_desc"].markAsTouched();
      }, err => {
        // this.data.formGroup.controls["currency"].patchValue(null);
        // this.data.formGroup.controls["delivery_date"].patchValue(null);
        this.data.formGroup.controls["item_category"].patchValue(null);
        // this.data.formGroup.controls["price"].patchValue(null);
        this.data.formGroup.controls["quantity"].patchValue(null);
        this.data.formGroup.controls["short_text"].patchValue(null);
        this.data.formGroup.controls["esn"].patchValue(null);
        this.data.formGroup.controls["ordering_unit"].patchValue(null);
        this.data.formGroup.controls["item_desc"].patchValue(null);
      });
    }


    public verifyFile(event: any): void {
      [...event.target.files].forEach((file: File) => {
            this.data.prFiles?.push({ file, formatSize: this._helperService.formatFileSize(file.size) });
      });
      console.log("prFiles", this.data.prFiles)
    }

    public clearFile(i:any): void {
      this.data.prFiles.splice(i,1);
    }

  ngOnDestroy(): void {
    this._subscriptions.forEach(x=>x?.unsubscribe());
  }
}
